import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private themeId: string | null = null;
  constructor() { }
  
  setThemeId() {
    this.themeId = localStorage.getItem('theme_id');
  }

  getThemeId() {
    return this.themeId;
  }
  clearThemeId() {
    this.themeId=null;
  }
}
